"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.implementService = exports.defineService = void 0;
var services_definitions_1 = require("@wix/services-definitions");
Object.defineProperty(exports, "defineService", { enumerable: true, get: function () { return services_definitions_1.defineService; } });
Object.defineProperty(exports, "implementService", { enumerable: true, get: function () { return services_definitions_1.implementService; } });
